import { AuthApiError } from '@supabase/supabase-js';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { supabaseClient } from 'src/auth/supabase';

export const useRequestOtpSupabase = (
    config?: UseMutationOptions<unknown, AuthApiError, { email: string }>
) =>
    useMutation<unknown, AuthApiError, { email: string }>({
        ...config,
        mutationKey: ['auth', 'otp', 'request'],
        mutationFn: async ({ email }) => {
            const res = await supabaseClient.auth.signInWithOtp({
                email,
                options: {
                    emailRedirectTo: window.location.origin,
                    shouldCreateUser: false,
                },
            });

            if (res.error) throw res.error;

            return res.data;
        },
    });
